require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.9@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 0etw
// module chunks = 0